export const API = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
  },
  FED_AUTH: {
    LOGIN: '/fed-auth/login',
    LOGOUT: '/fed-auth/logout',
  },
  FEDERATION: {
    RESOLVE: '/api/federations/resolve',
    GET_ME: '/api/federations/me',
  },
  FILES: {
    UPLOAD_TEMP:          '/api/files/upload-temp',
    UPLOAD:               '/api/files/upload',
    DOCUMENTS_BY_ENTITY: '/api/files/documents/types/:entity_type',
    DOCUMENTS_FOR_OBJECT:'/api/files/documents/:type_object/:id_object',
    ACTIVE_DOCUMENTS:    '/api/files/documents/:type_object/:id_object/active',
    DELETE_FILE:         '/api/files/manage/:id',
  },
};
